import { head } from 'lodash'
import RECORDING_TEST_PHRASE from '@/constants/recording-test-phrase'
import api from '@/services/api.ts'

export type SpeechRecognitionResultType = {
  qualityScore: number
}

const testSpeechRecognition = async (blobAudio: Blob) => {
  try {
    const formData = new FormData()
    const audio = new File(
      [blobAudio],
      `audio.${head(blobAudio.type.split(';'))?.split('/').pop()}`,
      {
        type: blobAudio.type
      }
    )
    formData.append('audio', audio)
    formData.append('text', RECORDING_TEST_PHRASE)
    const { data } = await api.patch<SpeechRecognitionResultType>(
      `/fluency-test/microphone-test`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return data
  } catch (e) {
    throw new Error('TEST_SPEECH_RECOGNITION_ERROR')
  }
}

export default testSpeechRecognition
